import { MockDebug } from '@tino-frontend/mocks'

import { receivablesDetailsAPIMock } from '@fixtures/apis/receivables'
import { billListAggregateCashinReceivable } from '@fixtures/apis/bill/list-v3/aggregate-cashin-receivable'
import { REACT_APP_MERCHANT_BFF_API_URL } from 'constants/envs'

// Service: bill
const MockDebugBillList: MockDebug = {
  title: 'Bill List',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v3/company/:companyId/bills`,
  method: 'get',
  delay: 2000,
  options: [
    {
      id: 'mock-bill-aggregate-cashin-receivable',
      title: 'Aggregate Cashin Receivable',
      status: 200,
      data: billListAggregateCashinReceivable.source,
    },
  ],
}

const MockDebugDetail: MockDebug = {
  title: 'Receivable Detail',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/company/:companyId/receivables/details`,
  method: 'get',
  delay: 1000,
  options: [
    {
      id: 'mock-detail-complete',
      title: 'Success',
      status: 200,
      data: receivablesDetailsAPIMock.source,
    },
    {
      id: 'mock-detail-error',
      title: '404 Not Found',
      status: 404,
      data: {},
    },
  ],
}

export const MockDebugReceivableDetail = [MockDebugBillList, MockDebugDetail]
